import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
import axiosClient from "../../../common/api/request";

// A 500 or a body that is not an object reads as the request's own message,
// the same rule the report downloads use for their error toasts.
const toRejectValue = (error) =>
  error?.response?.data &&
  typeof error.response.data === "object" &&
  error?.response?.status !== 500
    ? error.response.data
    : { Error: error?.message };

const createTopSoldProductsThunk = (endpoint) =>
  createAsyncThunk(
    `topSoldProductsV3/${endpoint}`,
    async (params, { rejectWithValue }) => {
      try {
        return await axiosClient.get(
          `${config.API_URL_V3}/top_sold_products/${endpoint}/`,
          { params }
        );
      } catch (error) {
        return rejectWithValue(toRejectValue(error));
      }
    }
  );

export const getTopSoldProductsSummary = createTopSoldProductsThunk("summary");
export const getTopSoldProductsRanking = createTopSoldProductsThunk("ranking");
// The share endpoint folds everything past the top 8 into "Other products".
// The chart lists every product (the legend pages through them), so it reads
// the ranking endpoint at its largest limit and works the percents out here.
// Products with a negative value stay in the total, as the backend counts them.
const SHARE_PRODUCTS_LIMIT = 100;
export const getTopSoldProductsShare = createAsyncThunk(
  "topSoldProductsV3/share",
  async (params, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V3}/top_sold_products/ranking/`,
        { params: { ...params, limit: SHARE_PRODUCTS_LIMIT } }
      );
      const rows = data?.results || [];
      const total = rows.reduce((sum, row) => sum + Number(row?.value || 0), 0);
      return {
        metric: data?.metric,
        total,
        results: rows.map((row) => ({
          ...row,
          pct: total ? (Number(row?.value || 0) / total) * 100 : null,
        })),
      };
    } catch (error) {
      return rejectWithValue(toRejectValue(error));
    }
  }
);
export const getTopSoldProductsDetails = createTopSoldProductsThunk("details");
// The product window: one request per part, each with its own state.
export const getTopSoldProductsInsights =
  createTopSoldProductsThunk("insights");
export const getTopSoldProductsInsightsDaily =
  createTopSoldProductsThunk("insights/daily");
export const getTopSoldProductsInsightsSizes =
  createTopSoldProductsThunk("insights/sizes");
export const getTopSoldProductsInsightsBreakdowns = createTopSoldProductsThunk(
  "insights/breakdowns"
);
export const getTopSoldProductsInsightsCustomers = createTopSoldProductsThunk(
  "insights/customers"
);
export const downloadTopSoldProducts = createTopSoldProductsThunk("download");
